// src/components/common/Header.tsx - CORRIGÉ : Suppression doublons farmer
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getTelegramStatus } from '../../services/telegramService';
import TelegramNotificationBanner from './TelegramNotificationBanner';
import SecurityIndicator from '../SecurityIndicator';
import OrderNotifications from '../OrderNotifications';

const Header = () => {
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [telegramLinked, setTelegramLinked] = useState<boolean | null>(null);
  const [showTelegramTooltip, setShowTelegramTooltip] = useState(false);
  
  const isAdmin = user?.is_admin || false;
  const isFarmer = user?.is_farmer || false;
  const isCustomer = user && !isAdmin && !isFarmer;

  useEffect(() => {
    if (user) {
      checkTelegramStatus();
    } else {
      setTelegramLinked(null);
    }
  }, [user]);

  const checkTelegramStatus = async () => {
    try {
      const status = await getTelegramStatus();
      setTelegramLinked(status.linked);
    } catch (error) {
      console.error('Erreur lors de la vérification du statut Telegram:', error);
      setTelegramLinked(false);
    }
  };

  return (
    <>
      <header className="bg-white shadow-md relative z-40">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to="/" className="text-2xl font-bold text-terracotta">
              BeninAgri
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-4">
              <Link to="/" className="text-slate hover:text-terracotta transition">
                Accueil
              </Link>
              <Link to="/products" className="text-slate hover:text-terracotta transition">
                Produits
              </Link>
              
              {user && (
                <Link to="/cart" className="text-slate hover:text-terracotta transition">
                  Panier
                </Link>
              )}
              
              {/* ✅ CORRECTION FARMER: Suppression doublons */}
              {isFarmer && (
                <>
                  {/* ✅ SUPPRIMÉ: Dashboard (doublon avec Espace Agriculteur) */}
                  <Link to="/farmer/orders" className="text-slate hover:text-terracotta transition">
                    Commandes
                  </Link>
                  <Link to="/my-products" className="text-slate hover:text-terracotta transition">
                    Mes produits
                  </Link>
                </>
              )}
              
              {/* Indicateur Telegram pour utilisateurs connectés non-liés */}
              {user && telegramLinked === false && (
                <div className="relative">
                  <Link
                    to="/telegram/setup"
                    className="relative bg-blue-500 text-white px-3 py-1 rounded-full text-xs hover:bg-blue-600 transition flex items-center"
                    onMouseEnter={() => setShowTelegramTooltip(true)}
                    onMouseLeave={() => setShowTelegramTooltip(false)}
                  >
                    📱 Telegram
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-2 h-2"></span>
                  </Link>
                  
                  {showTelegramTooltip && (
                    <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs rounded py-2 px-3 whitespace-nowrap z-10">
                      Activez les notifications Telegram
                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-b-gray-800"></div>
                    </div>
                  )}
                </div>
              )}

              {/* Notifications commandes pour farmers */}
              {isFarmer && <OrderNotifications />}

              {/* Indicateur de sécurité */}
              {user && <SecurityIndicator />}
              
              {/* ✅ GARDE SEULEMENT: Espace Agriculteur (supprime Dashboard) */}
              {isFarmer && (
                <Link to="/dashboard" className="text-white bg-terracotta hover:bg-olive px-4 py-2 rounded-md transition">
                  Espace Agriculteur
                </Link>
              )}
              
              {/* Bouton Espace Client */}
              {isCustomer && (
                <Link to="/customer-dashboard" className="text-white bg-terracotta hover:bg-olive px-4 py-2 rounded-md transition">
                  Espace Client
                </Link>
              )}
              
              {/* Bouton Admin */}
              {isAdmin && (
                <Link to="/admin" className="text-white bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded-md transition">
                  Administration
                </Link>
              )}
              
              {user ? (
                <div className="relative">
                  <button 
                    onClick={() => logout()}
                    className="text-white bg-olive hover:bg-terracotta px-4 py-2 rounded-md transition"
                  >
                    Déconnexion
                  </button>
                </div>
              ) : (
                <Link to="/login" className="text-white bg-olive hover:bg-terracotta px-4 py-2 rounded-md transition">
                  Connexion
                </Link>
              )}
            </nav>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-slate z-50"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="md:hidden mt-4 space-y-2 pb-4 border-t pt-2 relative z-50">
              <Link 
                to="/" 
                className="block text-slate hover:text-terracotta transition py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link 
                to="/products" 
                className="block text-slate hover:text-terracotta transition py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Produits
              </Link>
              
              {user && (
                <Link 
                  to="/cart" 
                  className="block text-slate hover:text-terracotta transition py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Panier
                </Link>
              )}

              {/* ✅ CORRECTION MOBILE FARMER: Suppression doublons */}
              {isFarmer && (
                <>
                  {/* ✅ SUPPRIMÉ: Dashboard mobile (doublon) */}
                  <Link 
                    to="/farmer/orders"
                    className="block text-slate hover:text-terracotta transition py-2"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    📦 Commandes reçues
                  </Link>
                  <Link 
                    to="/my-products"
                    className="block text-slate hover:text-terracotta transition py-2"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Mes produits
                  </Link>
                </>
              )}

              {/* Indicateur Telegram Mobile */}
              {user && telegramLinked === false && (
                <Link 
                  to="/telegram/setup"
                  className="block bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition"
                  onClick={() => setIsMenuOpen(false)}
                >
                  📱 Activer les notifications Telegram
                </Link>
              )}

              {/* Indicateur de sécurité Mobile */}
              {user && (
                <div className="flex items-center justify-between py-2 px-4 bg-gray-50 rounded-md">
                  <span className="text-sm text-gray-600">Sécurité de session :</span>
                  <SecurityIndicator />
                </div>
              )}
              
              {/* ✅ GARDE SEULEMENT: Espace Agriculteur mobile */}
              {isFarmer && (
                <Link 
                  to="/dashboard"
                  className="block bg-terracotta text-white py-2 px-4 rounded-md hover:bg-olive transition"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Espace Agriculteur
                </Link>
              )}
              
              {/* Bouton Espace Client Mobile */}
              {isCustomer && (
                <Link 
                  to="/customer-dashboard" 
                  className="block bg-terracotta text-white py-2 px-4 rounded-md hover:bg-olive transition"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Espace Client
                </Link>
              )}
              
              {/* Bouton Admin Mobile */}
              {isAdmin && (
                <Link 
                  to="/admin" 
                  className="block bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 transition"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Administration
                </Link>
              )}
              
              {/* Bouton Connexion/Déconnexion Mobile */}
              {user ? (
                <button 
                  onClick={() => {
                    logout();
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition"
                >
                  Déconnexion
                </button>
              ) : (
                <Link 
                  to="/login" 
                  className="block bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Connexion
                </Link>
              )}
            </nav>
          )}
        </div>
      </header>

      {/* Bannière Telegram mobile */}
      {user && telegramLinked === false && (
        <div className="md:hidden relative z-30">
          <TelegramNotificationBanner 
            variant="compact" 
            showCloseButton={true}
            className="mx-4 mt-2"
          />
        </div>
      )}
    </>
  );
};

export default Header;